import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
const placeholders = [1, 2, 3];
export function Testimonials() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-172" data-mp="3krp1qv22efll">
      <div className="mx-auto max-w-5xl" data-id="element-173" data-mp="3fz5ndvvjzgfq">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-174" data-mp="3fy2w3mubjbza">
          Voci dalle aule
        </p>
        <h2 className="mt-4 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-175" data-mp="36zin5dek8go9">
          Cosa Dicono gli Insegnanti di Musica
        </h2>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-176" data-mp="32290u6mgwl4n">
          {placeholders.map(item => <li key={item} className="flex flex-col items-center justify-center rounded-3xl border border-dashed border-navy/25 bg-white/60 p-9 text-center" data-id="element-177" data-mp="2s1qaqu4b88ea">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy-tint" data-id="element-178" data-mp="qac1oyvee8zv">
                <MessageSquareIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-179" data-mp="h67ya15u5i8s" />
              </span>
              <p className="mt-4 text-xs font-bold uppercase tracking-[0.16em] text-ink-soft" data-id="element-180" data-mp="m4rj1y8p0nzk">
                Recensione in arrivo
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xs leading-relaxed text-ink-soft" data-id="element-181" data-mp="c6llfstx640i">
          Le testimonianze verranno pubblicate appena raccolte da insegnanti che hanno provato
          Musica Pronta.
        </p>
      </div>
    </section>;
}